<template>
  <div class="container">
    <mt-header fixed title="质保详情" class="head" >
      <router-link v-if="isBack" to="/guarante" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header>
    <div class="group c_p_10 c_m_t_10 bg_white">
      <div  v-for="(item,index) in detail" :key="index" class="img c_m_r_10 c_rela" @click="checkDetail(item)">
        <img :src="item +'?imageView2/1/w/100/h/100'" alt="">
        <div class="img_model c_flex c_flex_center">{{item.indexOf('pdf')>-1 ?"PDF": item.slice(item.lastIndexOf('.')+1,item.length) }}</div>
      </div>
    </div>
    <div class="content c_m_t_10 c_h">
      <div class="c_flex c_flex_center bg_white">
        <div style="height: 70vh;width: 100%;">
          <!--<iframe :src="qiniu + item" width='100%' height='100%' frameborder='1'></iframe>-->
          <iframe :src="item" width='100% ' height='100%' frameborder="0" ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "guaranteDetail",
    data:function () {
      return {
        qiniu: this.$$api.mobile.qiniuDownload,
        detail:'',
        item:'',
        serverIp: 'static/pdf/web/viewer.html?file=',
        isBack:false,
      }
    },
    mounted:function () {
      var detail = this.$route.params.detail||this.$route.query.detail||'';
      var url = this.$route.query.url||"";
      if(detail){
        //this.$indicator.open('加载中...');
        this.$toast({ message: "加载中...", duration: 2000 });
        this.detail = detail.split(',');
        this.item = this.serverIp+encodeURIComponent(detail.split(',')[0]);
        //this.$indicator.close();
      }else{
        this.$router.push('/guarante');
      }
      if(!url){
        this.isBack = true;
      }
    },
    methods: {
      checkDetail:function (item) {
        //this.$indicator.open('加载中...');
        this.$toast({ message: "加载中...", duration: 2000 });
        this.item = this.serverIp+encodeURIComponent(item);
        //this.$indicator.close();
      },
    }
  }
</script>

<style scoped>
  .group{
    width: 100%;
    overflow-x: auto;
    overflow-y:hidden ;
    white-space: nowrap;
    box-sizing: border-box;
  }
  .group .img{
    width: 25vw;
    height: 25vw;
    background: #ccc;
    display: inline-block;
  }
  .group .img img{
    width: 25vw;
    height: 25vw;
    display: inline-block;
  }
  .group .img_model {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.5);
    z-index: 10;
    color: #fff;
  }
  .content{
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  .content>div{
    width: 100%;
    height: 100%;
  }
  .content img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/guaranteDetail.vue